import {
  HeaderTitle,
  RequestHeaderContainer,
} from './styles/RequestHeader.styled';

export const RequestHeader = () => {
  return (
    <RequestHeaderContainer>
      <HeaderTitle>Request Time-off</HeaderTitle>
    </RequestHeaderContainer>
  );
};
